/**
 * External dependencies
 */

export const getSelectedCarrierID = ( state ) => {
	return state.selectedCarrierId;
};

export const getSelectedDate = ( state ) => {
	return state.selectedDate;
};

export const getSelectedSlot = ( state ) => {
	return state.selectedSlot;
};

export const getProcessingMethodID = ( state ) => {
	return state.selectedProcessingId;
};

export const getCurrentRateId = ( state ) => {
	return state.currentRateId;
};
export const getCarriers = ( state ) => {
	return state.allCarriers;
};

export const initialize = ( state ) => {
	return state.initialized;
};
export const getDates = ( state ) => {
	return state.allDates;
};

export const updateDates = ( state ) => {
	return state.allDates;
};
export const getTimeSlots = ( state ) => {
	return state.allSlots;
};

export const updateTimeSlots = ( state ) => {
	return state.allSlots;
};
export const isDeliveryDateUpdating = ( state ) => {
	return state.isUpdate;
};

export const isRequired = ( state ) => {
	return state.isRequired;
};

export const addCartFee = ( state ) => {
	return state.selectedSlot;
};
